import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as toastr from 'toastr';

import userActions from './userActions';

import { Page, PageContent, PageHeader } from '../components/common';
import { ensureUserHasRole } from '../auth/authComponents';
import Utils, { SecurityRoles } from '../common/utils';

import FriendReferral from './referral/FriendReferral';
import SpouseReferral from './referral/SpouseReferral';

interface Props {
	currentUser: UserDetails;
	referrals: CustomerReferralResponse;
	actions: any;
}
interface State {
	isLoading: boolean;
	isSubmitting: boolean;
	isSubmittingSpousal: boolean;
}
class ReferPage extends React.Component<Props, State> {
	state = {
		isLoading: true,
		isSubmitting: false,
		isSubmittingSpousal: false,
	};

	componentDidMount() {
		this.props.actions.fetchReferrals(this.props.currentUser.id)
			.then(() => this.setState({
				isLoading: false,
			}));
	}
	
	isSpousalInviteDisabled = () => {
		const referees = this.props.referrals.referees || [];
		const hasAlreadyReferredSpouse = referees.some((referral: ReferredUser) => {
			return referral.isSpousalReferralUsed != null && referral.isSpousalReferralUsed;
		});

		return this.state.isLoading ||
			this.state.isSubmittingSpousal ||
			hasAlreadyReferredSpouse ||
			this.props.referrals.isSpousalReferralUsed!;
	}
	onSpousalInvite = (spousalName: string, spousalEmail: string, resetForm: Function) => {
		this.setState({ isSubmittingSpousal: true });
		this.props.actions.sendSpousalReferralInviteEmail(this.props.currentUser.id, spousalName, spousalEmail)
		.then(() => {
			this.setState({ isSubmittingSpousal: false });
			resetForm();
			toastr.success('Invite sent');
		});
	}

	isInviteDisabled = () => {
		return this.state.isLoading ||
			this.state.isSubmitting ||
			!this.props.referrals.referralEnabled ||
			this.props.referrals.remainingReferrals! === 0; 
	}
	onInvite = (name: string, email: string, resetForm: Function) => {
		this.setState({ isSubmitting: true });
		this.props.actions.sendReferralInviteEmail(this.props.currentUser.id, name, email)
		.then(() => {
			this.setState({ isSubmitting: false });
			resetForm();
			toastr.success('Invite sent');
		});
	}

	render() {

		return (
			<Page title="Referral">
				<PageContent>
					<PageHeader title="Referral" />
					<div className="border border-success px-3 py-4 text-center">
						<h2 className="h4 text-dark">Referral Balance: {Utils.formatCurrency(this.props.referrals.referralBalance)}</h2>
						<small>
							<strong className="d-block">
								{Utils.formatCurrency(this.props.referrals.paidReferral)} paid out
							</strong>
						</small>
						<small>Please note that credit for any referrals you may have made will be added to your account 31 days
									after the referred user has activated his or her policy.</small>
					</div>
					<div className="row">
						<div className="d-flex col-md mt-4">							
							<SpouseReferral
								referrals={this.props.referrals}
								currentUser={this.props.currentUser}
								onSpousalInvite={this.onSpousalInvite}
								disabled={this.isSpousalInviteDisabled()}
								isSubmittingSpousal={this.state.isSubmittingSpousal}
								fullFormWidth={this.props.referrals.referralEnabled}
							/>
						</div>
						{
							this.props.referrals.referralEnabled && 
							<div className="d-flex col-md mt-4">			
								<FriendReferral
									referrals={this.props.referrals}
									currentUser={this.props.currentUser}
									onInvite={this.onInvite} 
									disabled={this.isInviteDisabled()} 
									isSubmitting={this.state.isSubmitting}
									fullFormWidth={true}
								/>
							</div>
						}
					</div>
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		currentUser: state.auth.currentUser,
		referrals: state.user.referrals
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const ConnectedReferPage = connect(mapStateToProps, mapDispatchToProps)(ReferPage);
export default ensureUserHasRole(ConnectedReferPage as any, [SecurityRoles.Customer]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/user/ReferPage.tsx